function parsePresentWeather(code) {
    const intensity = {
        "-": "light",
        "+": "heavy",
    };

    const descriptors = {
        MI: "shallow",
        PR: "partial",
        BC: "patches",
        DR: "low drifting",
        BL: "blowing",
        SH: "showers",
        TS: "thunderstorm",
        FZ: "freezing",
        VC: "in the vicinity",
        RE: "recent",
    };

    const phenomena = {
        DZ: "drizzle",
        RA: "rain",
        SN: "snow",
        SG: "snow grains",
        IC: "ice crystals",
        PL: "ice pellets",
        GR: "hail",
        GS: "small hail or snow pellets",
        UP: "unknown precipitation",
        BR: "mist",
        FG: "fog",
        FU: "smoke",
        VA: "volcanic ash",
        DU: "widespread dust",
        SA: "sand",
        HZ: "haze",
        PY: "spray",
        PO: "dust/sand whirls",
        SQ: "squalls",
        FC: "funnel cloud",
        SS: "sandstorm",
        DS: "duststorm",
        "+FC": "tornado or waterspout"
    };

    // Extract intensity
    let intensityPrefix = '';
    if (code.startsWith('-') || code.startsWith('+')) {
        intensityPrefix = code[0];
        code = code.slice(1);
    }

    // Extract 'RE' (recent)
    let recent = false;
    if (code.startsWith('RE')) {
        recent = true;
        code = code.slice(2);
    }

    // Extract descriptor and phenomenon
    let descriptor = '';
    let phenomenon = '';

    for (let d in descriptors) {
        if (code.startsWith(d)) {
            descriptor = d;
            phenomenon = code.slice(d.length);
            break;
        }
    }

    if (!descriptor) {
        phenomenon = code;
    }

    const descriptionParts = [];

    if (recent) descriptionParts.push("recent");
    if (intensityPrefix) descriptionParts.push(intensity[intensityPrefix]);
    if (descriptors[descriptor]) descriptionParts.push(descriptors[descriptor]);
    if (phenomena[phenomenon]) {
        descriptionParts.push(phenomena[phenomenon]);
    } else if (descriptor && phenomena[descriptor]) {
        // In case the code only contains a phenomenon
        descriptionParts.push(phenomena[descriptor]);
    }

    if (descriptionParts.length === 0) {
        return "Unknown code";
    }

    return descriptionParts.join(" ");
}

export default parsePresentWeather;
